<template>
  <div class="auth-page-container">
    <h2 class="auth-page-title font-500">
      {{ $t('pagelayout.order-history') }}
    </h2>
    <section class="auth-page-section">
      <b-form v-show="true" @submit.prevent="search" class="mx-2">
        <b-row>
          <div class="col-12 col-md-6 mb-ten">
            <auto-complete
              :items="brands"
              :placeholder="$t('keyword')"
              :buttonVisible="false"
              :required="false"
              displayValue="symbol"
              @query="getBrands"
              @selected="setBrandQuery"
              @click="initBrandQuery"
              is-brand
            />
          </div>
          <div class="col-12 col-md-6">
            <div class="row">
              <date-picker
                :max-date="new Date()"
                @change="dateChange"
                range
                :datesProp="initialDates"
                class="mr-3"
              />
              <ic-button size="tn" type="submit" class="card-button mt-0">
                {{ $t('helper.search') }}
              </ic-button>
            </div>
          </div>
        </b-row>
      </b-form>
      <div class="table-container">
        <table class="ic-table">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('brand.symbol.title') }}</th>
              <th>{{ $t('trade.date') }}</th>
              <th>{{ $t('trade.side') }}</th>
              <th class="right">
                {{ $t('order.unit-price') }}
              </th>
              <th class="right">{{ $t('order.quantity') }}</th>
              <th class="right">{{ $t('order.trade-amount') }}</th>
              <th class="right">{{ $t('order.fee') }}</th>
              <th class="right">{{ $t('order.total-amount') }}</th>
              <th class="right">{{ $t('order.taxAmount') }}</th>
              <th>{{ $t('order.status') }}</th>
            </tr>
          </thead>
          <tbody v-if="items && items.length">
            <tr v-for="(item, i) in items" :key="`order${i}`">
              <td>{{ i + 1 }}</td>
              <td>{{ item.symbol | symbol }} <span class="exchange-code">/ {{ item.exchange_server_code ?? '--' }}</span></td>
<!--              <td>{{ item.created_at | formatDate('dateTime') }}</td>-->
              <td>{{ item.created_at | formatDate('dateTime') }}</td>
              <td :class="['side-cell', item.side === 1 ? 'is-buy' : 'is-sell']">
                {{ item.side === 1 ? $t('order.buy') : $t('order.sell') }}
              </td>
              <td class="right">{{ item.unit_price | currency('', '₮') }}</td>
              <td class="right">
                {{ item.quantity | currency('no-precision', '') }}
              </td>
              <td class="right">{{ tradeAmount(item) | currency('', '₮') }}</td>
              <td class="right">{{ totalFee(item) | currency('', '₮') }}</td>
              <td class="right">{{ item.order_amount | currency('', '₮') }}</td>
              <td class="right">{{ item.total_tax_amount | currency('', '₮') }}</td>
              <td
                :class="[
                  item.exec_type == 'P' ? 'text-yellow' : '',
                  item.exec_type == 'F' ? 'text-green' : '',
                  item.exec_type == '4' ||
                  item.exec_type == '8' ||
                  item.exec_type == '6' || item.exec_type == 'C'
                    ? 'text-red'
                    : '',
                ]"
              >
                <!--Хэсэгчлэн биелсэн тохиолдолд-->
                <span
                  v-if="Array.isArray(item.order_details) && (item.order_details.length > 1 || ((item.exec_type === 'C' || item.exec_type === 'P') && item.order_details.length >= 1))"
                  class="d-flex align-items-center"
                  @click="showOrderDetails(item)"
                  >{{ $t('order.state.' + item.exec_type) }}
                  <i class="sr sr-eye-open ml-2"></i>
                </span>
                <span v-else>{{
                    $t('order.state.' + item.exec_type)
                  }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination-nav
        class="pt-4"
        v-if="items && items.length"
        v-model="page.number"
        align="center"
        :link-gen="linkGen"
        :number-of-pages="page.totalPages || 1"
        use-router
      />
    </section>

    <ic-dialog :show="showOrderDetailsDialog">
      <div class="dialog-box" style="width: auto; overflow: auto; max-height: 70vh">
        <div class="row align-items-center mb-ten">
          <div class="col">
            <h3 v-if="selectedItem" class="mb-0">
              {{ selectedItem.symbol | symbol }} {{ $t('helper.more') }}
            </h3>
          </div>
          <a
            @click.stop="showOrderDetailsDialog = false"
            class="icon-btn close-btn mr-row"
          >
            <i class="sr sr-close"></i>
          </a>
        </div>
        <table class="ic-table md mb-ten">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('trade.date') }}</th>
              <th class="right">
                {{ $t('order.unit-price') }}
              </th>
              <th class="right">{{ $t('order.quantity') }}</th>
              <th class="right">Биелсэн</th>
              <th class="right">Үлдсэн</th>
              <th class="right">{{ $t('order.trade-amount') }}</th>
              <th class="right">{{ $t('order.fee') }}</th>
              <th class="right">{{ $t('order.total-amount') }}</th>
              <th class="right">{{ $t('order.taxAmount') }}</th>
            </tr>
          </thead>
          <tbody
            v-if="
              selectedItem &&
              selectedItem.order_details &&
              selectedItem.order_details.length
            "
          >
            <tr
              v-for="(item, i) in selectedItem.order_details"
              :key="`order${i}`"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ item.created_at | formatDate('dateTime') }}</td>
              <td class="right">{{ item.last_px || 0 | currency('', '₮') }}</td>
              <td class="right">
                {{
                  calcLeft(
                    selectedItem.quantity,
                    selectedItem.order_details,
                    i
                  ) || 0 | currency('no-precision', '')
                }}
              </td>
              <td class="right">
                {{ item.last_qty || 0 | currency('no-precision', '') }}
              </td>
              <td class="right">
                {{ item.leaves_qty || 0 | currency('no-precision', '') }}
              </td>
              <td class="right">
                {{ detailTradeAmount(item) | currency('', '₮') }}
              </td>
              <td class="right">
                {{ detailFeeAmount(item) | currency('', '₮') }}
              </td>
              <td class="right">
                {{ detailTotalAmount(item) | currency('', '₮') }}
              </td>
              <td class="right">
                {{ item.tax_amount | currency('', '₮') }}
              </td>
            </tr>
          </tbody>
          <span v-else>
            {{
              $t('helper.not-found-slot', {
                slot: $tc('helper.more', 1),
              })
            }}</span
          >
        </table>
        <div
          style="opacity: 50%"
          v-if="selectedItem && selectedItem.sent === 3"
        >
          Цуцалсан
        </div>
      </div>
    </ic-dialog>
  </div>
</template>
<script>
import { ExecType } from '../constants'
import { mapGetters, mapState } from 'vuex'
import api from '../api/stoTrade'
import OrderInfo from '../components/OrderInfo'
import AutoComplete from '../components/AutoComplete'
import PageLayout from '../components/PageLayout'
import DatePicker from '../components/DatePicker'
import moment from 'moment'

export default {
  name: 'orderHistoryView',
  components: {
    AutoComplete,
    OrderInfo,
    PageLayout,
    DatePicker,
  },
  data() {
    const initial = {
      start: moment().subtract(1, 'months').toDate(),
      end: new Date(),
    }
    return {
      ExecType,
      initialDates: initial,
      isLoading: false,
      page: {
        number: 0,
        totalPages: 1,
      },
      items: [],
      brands: [],
      filters: {
        symbol: '',
        from: '',
        to: '',
      },
      selectedItem: null,
      showOrderDetailsDialog: false,
    }
  },
  created() {
    this.getBrands = _.debounce(this.getBrands, 400)
  },
  mounted() {
    this.fetchData()
    this.getBrands()
  },
  computed: {
    ...mapState('common', ['dark']),
  },
  methods: {
    calcLeft(qty, item, index) {
      if (index > 0) {
        return item[index - 1].leaves_qty
      } else {
        return qty
      }
    },
    showOrderDetails(item) {
      this.selectedItem = item
      this.showOrderDetailsDialog = true
    },
    totalFee(item) {
      if (!Array.isArray(item.order_details) || item.order_details.length === 0) {
        return parseFloat(item.fee) || 0
      }

      return item.order_details.reduce((sum, detail) => {
        return sum + (parseFloat(detail.fee) || 0)
      }, 0)
    },
    tradeAmount(item) {
      return (parseFloat(item.order_amount) || 0) - this.totalFee(item)
    },
    detailTradeAmount(item) {
      return (parseFloat(item.last_px) || 0) * (parseInt(item.last_qty) || 0)
    },
    detailFeeAmount(item) {
      return parseFloat(item.fee) || 0
    },
    detailTotalAmount(item) {
      return this.detailTradeAmount(item) + this.detailFeeAmount(item)
    },
    dateChange({ start, end }) {
      if (start && end) {
        this.filters.from = moment(start).format('YYYY-MM-DD')
        this.filters.to = moment(end).format('YYYY-MM-DD')
      }
    },
    getRequestQuery() {
      this.mapQueryToFilters()
      const query = this.mapFiltersToQuery()
      return { ...query, per_page: 12 }
    },
    mapQueryToFilters() {
      const { page, ...filters } = this.$route.query
      this.filters = { ...this.filters, ...filters }
      if (page) this.page.number = _.parseInt(page)
    },
    mapFiltersToQuery() {
      const nonEmptyFilters = _.pickBy(
        this.filters,
        (v) => !_.isEmpty(v) || !!v
      )
      return {
        ...nonEmptyFilters,
        page: this.page.number,
      }
    },
    linkGen(page) {
      const query = { ...this.$route.query }
      if (!query.page && page === 1) {
        return { query }
      }
      query.page = page
      return { query }
    },
    async fetchData() {
      this.isLoading = true
      try {
        const {
          data: { data, ...page },
        } = await api.orderHistory(this.getRequestQuery())
        this.page = { totalPages: page.last_page, number: page.current_page }
        this.items = [...data]
      } catch (e) {
        console.error(e)
      } finally {
        if (this.$refs['order-history-container'])
          this.$refs['order-history-container'].scrollTo(0, 0)
      }
      this.isLoading = false
    },
    search() {
      this.page.number = 0
      const query = this.mapFiltersToQuery()
      this.$router.push({ query })
    },
    // Methods for autocomplete
    async getBrands(query) {
      this.isLoading = true
      try {
        let {
          data: { data },
        } = await api.brandList({ word: query, page: 0, per_page: 50 })
        this.brands = data
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },
    initBrandQuery() {
      if (!this.filters.symbol) this.getBrands('')
    },
    setBrandQuery(value) {
      this.filters.symbol = value ? value.symbol : null
    },
  },
  watch: {
    '$route.query': {
      handler: 'fetchData',
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.collapse-btn {
  border-radius: 25px;
}
.collapse-btn:disabled {
  color: #5e5e5e;
  background-color: #ddd;
  border-color: #eee;
  cursor: not-allowed;
}
.detailed-more {
  cursor: pointer;
}

.side-cell.is-buy {
  color: rgb(var(--rgb-system-green));
}

.side-cell.is-sell {
  color: rgb(var(--rgb-system-red));
}
</style>

<style lang="scss" src="../../sass/partials/sidebar-submenu.scss"></style>
